module.exports = __webpack_public_path__ + "static/media/profile-image-zoom.0570828e.png";